import { Button, Card, CardContent, Text } from "@prismicio/editor-ui"

interface EmptyTableCardProps {
  onAddFirstSlice: () => void
}

export function EmptySliceTableCard(props: EmptyTableCardProps) {
  const { onAddFirstSlice } = props

  return (
    <Card variant="outlined" color="grey3" paddingInline={24} paddingBlock={12}>
      <CardContent gap={4}>
        <Text variant="emphasized" color="grey11" align="center">
          Create your page
        </Text>

        <Text variant="small" color="grey11" align="center">
          Your page is made up of Slices. Each Slice is a section.
        </Text>

        <Button
          size="small"
          sx={{ marginTop: 4, alignSelf: "center" }}
          onClick={onAddFirstSlice}
        >
          Add Slice
        </Button>
      </CardContent>
    </Card>
  )
}
